import { jsxs as o, jsx as t, Fragment as s } from "react/jsx-runtime";
import { useTranslation as _ } from "../../hooks/useTranslation.js";
import "react";
import { classes as l } from "../../utils/styles.js";
import "../Context/index.js";
import "../IconButton/index.js";
import { ProductCard as p } from "../ProductCard/index.js";
import "../../pagination-BeOG0tbT.js";
import "../ProductTable/TableRowGroup.js";
import { Spacer as a } from "../Spacer/index.js";
import { ProductCardList as f } from "../ProductCardList/index.js";
import "../../types/apiSchema.js";
import "../../types/localizationSchema.js";
import g from "./salesBatches.module.js";
const H = ({ batches: i, className: d, titleClassName: n }) => {
  const { t: e } = _();
  return i != null && i.length ? /* @__PURE__ */ o("div", { className: d, children: [
    /* @__PURE__ */ o(
      "h2",
      {
        className: l([
          ...n ? [n] : [],
          g.batchesHeader
        ]),
        children: [
          e("product_batches"),
          " (",
          i == null ? void 0 : i.length,
          ")"
        ]
      }
    ),
    /* @__PURE__ */ t(f, { children: i == null ? void 0 : i.map((r, u) => {
      var m;
      return /* @__PURE__ */ o(s, { children: [
        /* @__PURE__ */ t(
          p,
          {
            productName: (((m = r.product_descriptions[0]) == null ? void 0 : m.name) || r.label) ?? "",
            gtin: r.order_unit_gtin ? r.order_unit_gtin : r.base_unit_gtin || "",
            sapCode: r.sapuska_code ?? "",
            baseUnit: r.base_unit ?? "",
            salesUnit: r.order_unit ?? "",
            amount: r.base_units ?? 0
          }
        ),
        /* @__PURE__ */ t(a, { size: 20 })
      ] }, `${r.order_unit_gtin}_${u}_card`);
    }) })
  ] }) : null;
};
export {
  H as SalesBatches
};
